import { useEffect, useRef, useState } from 'react'

import { FilterMatchMode } from 'primereact/api'
import { Button } from 'primereact/button'
import { Tag } from 'primereact/tag'
import { Icon } from 'antd'

import { RULES, validRule } from '../../../../constants/Entitlements'
import { api, request } from '../../../../util/handlerRequestUtil'
import { exportCSV, exportExcel } from '../../../../util/exportUtils'
import Header from './Header'
import { getCurrentReferencePeriodId } from '../../../../util/getCurrentReferencePeriod'
import DataTable from '../../../../components/DataTable/DataTable'

export const ListActionsPage = function ({ history }) {
  const [actionsList, setActionsList] = useState([])
  const [referencePeriods, setReferencePeriods] = useState([])
  const [selectedReferencePeriod, setSelectedReferencePeriod] = useState(null)
  const [actionsIsActive, setActionsIsActive] = useState(true)
  const dt = useRef(null)
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    descricao: { value: null, matchMode: FilterMatchMode.CONTAINS },
    tipodevisita: { value: null, matchMode: FilterMatchMode.CONTAINS },
    agricultor: { value: null, matchMode: FilterMatchMode.CONTAINS },
    datadeexecucao: { value: null, matchMode: FilterMatchMode.CONTAINS },
    profissional: { value: null, matchMode: FilterMatchMode.CONTAINS },
    distrito: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.CONTAINS }
  })
  const [globalFilterValue, setGlobalFilterValue] = useState('')

  useEffect(() => {
    const hasAccess = validRule(RULES.ACTION) // Não deixa acessar a tela
    if (!hasAccess) {
      return history.push('/home')
    }

    async function fetchData() {
      const referencePeriods = await request(api.listSafraDropdown({ active: true }))
      const currentReferencePeriod = getCurrentReferencePeriodId(referencePeriods)
      setReferencePeriods(referencePeriods)
      setSelectedReferencePeriod(currentReferencePeriod)
    }
    fetchData()
  }, [])

  useEffect(() => {
    if (selectedReferencePeriod) {
      getActions({ active: actionsIsActive, safraId: selectedReferencePeriod })
    }
  }, [actionsIsActive, selectedReferencePeriod])

  const getActions = async (params) => {
    const items = await request(api.listActionsViewVisitas({ ...params }))
    setActionsList(items)
  }

  const onGlobalFilterChange = (e) => {
    const value = e.target.value
    let _filters = { ...filters }

    _filters['global'].value = value

    setFilters(_filters)
    setGlobalFilterValue(value)
  }

  const exportCSVData = () => {
    exportCSV(actionsList, 'lista_de_visitas')
  }

  const exportExcelData = () => {
    exportExcel(actionsList, 'lista_de_visitas')
  }

  const getStatusSeverity = (status) => {
    switch (status) {
      case 'REALIZADA':
        return 'success'
      case 'ATRASADA':
        return 'danger'
      case 'PLANEJADA':
        return 'info'
      case 'NÃO PLANEJADA':
        return 'primary'
      default:
        return 'info'
    }
  }

  const statusBodyTemplate = ({ status }) => {
    return <Tag value={status} severity={getStatusSeverity(status.trim())} />
  }

  const editBodyTemplate = ({ id, actionTypeId }) => {
    return (
      <Button className="p-button-text" onClick={() => history.push(`/actions/${actionTypeId}/${id}`)}>
        <Icon type="edit" className="default-actionContent-icon" />
      </Button>
    )
  }

  const columns = [
    { header: 'Descrição', field: 'descricao', filterField: 'descricao', responsive: true },
    { header: 'Tipo de visita', field: 'tipodevisita', filterField: 'tipodevisita', responsive: true },
    { header: 'Agricultor', field: 'agricultor', filterField: 'agricultor', responsive: true },
    { header: 'Data da visita', field: 'datadeexecucao', filterField: 'datadeexecucao', responsive: true },
    { header: 'Profissional', field: 'profissional', filterField: 'profissional', responsive: true },
    { header: 'Distrito', field: 'distrito', filterField: 'distrito', responsive: true },
    {
      header: 'Status',
      field: 'status',
      filterField: 'status',
      width: '9rem',
      responsive: true,
      body: statusBodyTemplate
    },
    { header: 'Editar', body: editBodyTemplate, width: '5rem', responsive: true }
  ]

  return (
    <div className="card">
      <Header
        selectedReferencePeriod={selectedReferencePeriod}
        referencePeriods={referencePeriods}
        setSelectedReferencePeriod={setSelectedReferencePeriod}
        globalFilterValue={globalFilterValue}
        onGlobalFilterChange={onGlobalFilterChange}
        exportCSV={exportCSVData}
        exportExcelData={exportExcelData}
        history={history}
        actionsIsActive={actionsIsActive}
        setActionsIsActive={setActionsIsActive}
      />
      <DataTable ref={dt} itemsList={actionsList} filters={filters} columns={columns} emptyMessage="actionsEmpty" />
    </div>
  )
}
